import React from "react";
import { CommunityProps } from "../../types";
import { ChatList, Shimmer, SkeletonElement } from "..";

type RightSideBarProps = {
  community: CommunityProps | null;
  loading: boolean;
};

const RightSideBar: React.FC<Partial<RightSideBarProps>> = ({
  community,
  loading,
}) => {
  const MaxLength = 300;

  const [isExpanded, setIsExpanded] = React.useState(false);

  function capitalizeFirstLetter(str: any) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
  }

  const longText = capitalizeFirstLetter(community?.description) || ""; // the empty string is there to avoid an undefine error.
  const userID = window.localStorage.getItem("user");

  return (
    <div className="hidden lg:flex flex-col font-Poppins gap-4 w-full ">
      <div className=" w-full   rounded py-4 px-3 bg-white shadow flex flex-col gap-3 ">
        <h5 className=" font-medium text-[9.2px] text-lightGreyText">ABOUT</h5>
        {loading && (
          <div className="relative overflow-hidden w-full">
            <SkeletonElement type="text" />
            <Shimmer />
          </div>
        )}
        {!loading &&
          (isExpanded ? (
            <p className="text-justify text-xs font-normal">{longText}</p>
          ) : (
            <p className="text-justify  text-xs font-normal ">
              {longText.length <= MaxLength
                ? longText
                : longText.slice(0, MaxLength) + "..."}

              {longText.length > MaxLength && (
                <span
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="cursor-pointer text-lightGreen"
                >
                  {isExpanded ? "See less" : "See more"}
                </span>
              )}
            </p>
          ))}
      </div>
      <div className="w-full bg-white rounded shadow py-4 px-2 font-Poppins">
        {/* {loading && (
        <div>
          <div className="mb-3 ml-1">
            <SkeletonElement type="title" />
          </div>
          {[1, 2, 3].map((n) => (
            <SkeletonSugestedCom key={n + 2} />
          ))}
        </div>
      )} */}
        <div className="mb-6">
          <h3 className="text-[10px] text-lightGreyText font-medium">
            YOUR COMMINUTY CHATS
          </h3>
        </div>

        <div className="grid gap-3 items-center rounded-sm">
          {community?.members
            ?.filter((com) => com.id !== userID)
            .map((com, index) => {
              return <ChatList community={com} key={Math.random()+com.id} index={index} />;
            })}
        </div>
      </div>
    </div>
  );
};

export default RightSideBar;
